import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

const formatter = (inputDate: string): string => {
  const outputDate = inputDate
    ? format(parseISO(inputDate), 'dd/MM/yyyy')
    : inputDate;
  return outputDate;
};

const dateFormat = (datetime: Date, locale: string): string => {
  const dateTimeFormat = Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: '2-digit'
  });
  const date = dateTimeFormat.format(datetime);
  return date;
};

export { formatter, dateFormat };
